import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {Spinner} from 'wix-ui-tpa';
import styles from './Loading.scss';

function Loading({className}) {
  return (
    <div className={classNames(styles.loadingWrapper, className)} data-hook="loaderWrapper" aria-hidden="true">
      <Spinner />
    </div>
  );
}

Loading.propTypes = {
  className: PropTypes.string,
};

export {Loading};
